module.exports = __webpack_public_path__ + "static/img/guide-31.a745860a.png";